// lib/search/searchHighlight.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var style = {
  color: "red"
};
var SearchHighlight = ({
  text,
  search
}) => {
  if (text === void 0 || (text ?? "") === "" || search === void 0 || (search ?? "") === "") {
    return text;
  }
  const index = text.toLowerCase().indexOf(search.toLowerCase());
  if (search === "" || index === -1) {
    return text;
  }
  const prefix = text.substring(0, index);
  const match = text.substring(index, index + search.length);
  const suffix = text.substring(index + search.length, text.length);
  return /* @__PURE__ */ jsxs("span", { children: [
    prefix,
    /* @__PURE__ */ jsx("span", { style, children: match }),
    suffix
  ] });
};
export {
  SearchHighlight
};
